import React from 'react';
import moment from 'moment';
import DatePicker from 'react-bootstrap-date-picker';
import Select from 'react-select';
import 'whatwg-fetch';
import { postEntity } from 'src/utils/entityApi';
import withAuth from 'src/hoc/withAuth';

const apiDealType = '/api/dealType/';
const apiEmployeeShow = '/api/employee/';
const apiDomainType = '/api/domains/';
const apiOriginType = '/api/origin/';
const apiAgencyType = '/api/agency/';

const oriState = {
  dataDealType: undefined,
  dataEmployee: undefined,
  name: undefined,
  desiredClotureDate: moment().format('YYYY-MM-DD'),
  domain: { id: 1, name: 'Télécom' },
  domainTypes: undefined,
  origin: undefined,
  originTypes: undefined,
  originAgency: { id: 0, name: 'France' },
  agencyTypes: [{ id: 0, name: 'France' }],
  customerId: undefined,
  typeId: -1,
  employeeSelectedId: -1,
  customerContacts: undefined,
  customerExternalContacts: undefined,
  interlocutors: undefined,
};

class ModalDealPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.close = this.close.bind(this);
    this.findEmployee = this.findEmployee.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleDateChange(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      desiredClotureDate: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }

  handleInputSelectChange(val) {
    const value = val ? val['id'] : undefined;

    this.setState({
      employeeSelectedId: value,
    });
  }

  handleSelectChange(val, typeSelect) {
    const newState = { ...this.state, [typeSelect]: val };
    if (typeSelect === 'domain') {
      newState.typeId = undefined;
    }
    this.setState(newState);
  }

  handleInputSelectChangeMulti(val, typeSelect) {
    this.setState({
      [typeSelect]: val,
    });
  }

  componentDidMount() {
    // Preset with the trigger customer infos
    this.setState({
      customerId: this.props.myCustomer.id,
      customerContacts: this.props.myCustomer.customerContacts,
      customerExternalContacts: this.props.myCustomer.customerExternalContacts,
    });

    // Fetch GET
    let queryURL = apiDealType;
    let graphQL = '{ dealTypes{id, name, active, domain{id, name}} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({
          dataDealType: (data['data']['dealTypes'] || []).filter((type) => type.active),
        });
      })
      .catch((error) => {
        console.log('erreur fetch deal types');
      });
    //////////////////////////////////
    this.getDomainTypes();
    this.getOriginTypes();
    this.getAgencyTypes();
    this.findEmployee();
  }

  findEmployee() {
    let queryURL = apiEmployeeShow;
    let graphQL = '{ employees{ id, firstname, lastname } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['employees']) {
            this.setState({
              dataEmployee: (data['data']['employees'] || []).map((employee) => ({
                ...employee,
                username: `${employee.firstname || ''} ${employee.lastname || ''}`,
              })),
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch list employees entity: \n' + error);
        }.bind(this)
      );
  }

  getDomainTypes() {
    let queryURL = apiDomainType;
    let graphQL = '{ domains{id, name} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            domainTypes: data['data']['domains'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch domain types');
        }.bind(this)
      );
  }

  getAgencyTypes() {
    let queryURL = apiAgencyType;
    let graphQL = '{ agencies{id, name} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({
          agencyTypes: [{ id: 0, name: 'France' }, ...data['data']['agencies']],
        });
      })
      .catch((error) => {
        console.log('erreur fetch agency types');
      });
  }

  getOriginTypes() {
    let queryURL = apiOriginType;
    let graphQL = '{ origins(active: 1){id, labelOrigin, agency{ id }}}';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            originTypes: data['data']['origins'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch origin types');
        }.bind(this)
      );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.myCustomer.name !== this.props.myCustomer.name) {
      let contacts = [];
      let externalContacts = [];
      for (let i = 0; i < this.props.myCustomer.customerContacts.length; i++) {
        contacts.push(this.props.myCustomer.customerContacts[i]);
        contacts[i].label = '' + contacts[i].name + ' ' + contacts[i].lastname;
      }
      // We also add the trigger contact
      if (this.props.myCustomer.triggerContact) {
        const isContactExist =
          -1 !== contacts.findIndex((contact) => contact.id === this.props.myCustomer.triggerContact.id);

        if (!isContactExist) {
          contacts.push(this.props.myCustomer.triggerContact);
          contacts[contacts.length - 1].label =
            '' + contacts[contacts.length - 1].name + ' ' + contacts[contacts.length - 1].lastname;
        }
      }
      for (let i = 0; i < this.props.myCustomer.customerExternalContacts.length; i++) {
        externalContacts.push(this.props.myCustomer.customerExternalContacts[i]);
        externalContacts[i].label = '' + externalContacts[i].name + ' ' + externalContacts[i].lastname;
      }
      this.setState({
        name: this.props.myCustomer.name + ' :',
        customerContacts: contacts,
        customerExternalContacts: externalContacts,
      });
    }
  }

  checkFormValid() {
    return (
      this.state.name &&
      this.state.name.trim() !== '' &&
      this.state.desiredClotureDate &&
      this.state.typeId &&
      this.state.typeId !== -1 &&
      (this.state.interlocutors || []).length > 0
    );
  }

  filterOriginsByAgency = () => {
    if (this.state.originAgency && this.state.originAgency.id !== 0) {
      return this.state.originTypes.filter((originType) => (originType.agency || {}).id === this.state.originAgency.id);
    }

    return this.state.originTypes;
  };

  render() {
    if (this.props.isOpen === false) return null;

    const { dataDealType } = this.state;
    const { dataEmployee } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Créer Affaire</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <div className='form-group'>
                  <label>Nom</label>
                  <input
                    name='name'
                    value={this.state.name}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                  />
                </div>
                <div className='form-group'>
                  <label>Date de cloture désirée</label>
                  <DatePicker
                    calendarContainer={this}
                    name='desiredClotureDate'
                    value={this.state.desiredClotureDate}
                    onChange={this.handleDateChange}
                    dateFormat='YYYY-MM-DD'
                  />
                </div>

                <div className='form-group'>
                  <label>Domaine</label>
                  {this.state.domainTypes && (
                    <Select
                      className='inputModalSelect'
                      name='domain'
                      value={this.state.domain}
                      labelKey={'name'}
                      valueKey={'id'}
                      options={this.state.domainTypes}
                      clearable={false}
                      onChange={(val) => this.handleSelectChange(val, 'domain')}
                    />
                  )}
                </div>

                <div className='form-group'>
                  <label>Filtrer les origines par agence</label>
                  {this.state.agencyTypes && (
                    <Select
                      className='inputModalSelect'
                      name='originAgency'
                      value={this.state.originAgency}
                      labelKey={'name'}
                      valueKey={'id'}
                      options={this.state.agencyTypes}
                      clearable={false}
                      onChange={(val) => this.handleSelectChange(val, 'originAgency')}
                    />
                  )}
                </div>

                <div className='form-group'>
                  <label>Origine</label>
                  {this.state.originTypes && (
                    <Select
                      className='inputModalSelect'
                      name='origin'
                      value={this.state.origin}
                      labelKey={'labelOrigin'}
                      valueKey={'id'}
                      options={this.filterOriginsByAgency()}
                      clearable={false}
                      onChange={(val) => this.handleSelectChange(val, 'origin')}
                    />
                  )}
                </div>

                <div className='form-group'>
                  <label>Type d'affaire</label>
                  <Select
                    className='inputModalSelect'
                    name='typeId'
                    value={this.state.typeId}
                    labelKey={'name'}
                    valueKey={'id'}
                    options={this.filterDealTypesByDomain(this.state.dataDealType, this.state.domain)}
                    onChange={(val) => this.handleSelectChange((val || {}).id || undefined, 'typeId')}
                    noResultsText={'Aucun résultat'}
                    placeholder={'Choisir...'}
                    clearValueText={'Supprimer'}
                  />
                </div>
                <div className='form-group'>
                  <label>Interlocuteurs</label>
                  <Select
                    multi={true}
                    className='inputModalSelect'
                    name='interlocutors'
                    value={this.state.interlocutors}
                    labelKey={'label'}
                    valueKey={'label'}
                    options={this.state.customerContacts
                      .concat(this.state.customerExternalContacts)
                      .filter((contact) => !contact.deleted)}
                    onChange={(val) => this.handleInputSelectChangeMulti(val, 'interlocutors')}
                    noResultsText={'Aucun résultat'}
                    clearValueText={'Supprimer'}
                  />
                </div>
                <div className='form-group'>
                  <label>
                    Employé en charge <i>(si différent)</i>
                  </label>
                  <Select
                    className='inputModalSelect'
                    name='employeeSelectedId'
                    value={this.state.employeeSelectedId}
                    labelKey={'username'}
                    valueKey={'id'}
                    options={dataEmployee}
                    onChange={this.handleInputSelectChange}
                    noResultsText={'Aucun résultat'}
                    placeholder={'Nom'}
                    clearValueText={'Supprimer'}
                  />
                </div>
                <div className='form-group'>
                  <label>Client déclencheur</label>
                  <select
                    name='customerId'
                    value={this.state.customerId}
                    onChange={this.handleInputChange}
                    className='form-control'
                    disabled
                  >
                    <option value={this.state.customerId}>{this.props.myCustomer.name}</option>
                  </select>
                </div>
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Créer</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  filterDealTypesByDomain = (dealTypes = [], domain) => {
    if (!domain || !('id' in domain)) {
      return dealTypes;
    }
    return dealTypes.filter((dealType) => (dealType.domain || {}).id === (domain || {}).id);
  };

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        let json = {
          deal: {
            name: this.state.name,
            desiredClotureDate: moment(this.state.desiredClotureDate).format('YYYY-MM-DD HH:mm'),
            customer: {
              id: this.props.myCustomer.id,
            },
            type: {
              id: this.state.typeId,
            },
            interlocutors: this.state.interlocutors,
          },
          domain: this.state.domain,
          origin: this.state.origin,
        };

        if (this.state.employeeSelectedId !== -1) {
          // existing contact
          json['employee'] = {
            id: this.state.employeeSelectedId,
          };
        }

        this.props.onPostResult('deal', postEntity(this.props.authFetch, 'deal', json));
        this.close();
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalDealPost);
